<template>

    <div class="reportblock" >
        <v-overlay :value="linkAdd" @click="linkAdd = false">
            <v-card light>
                <v-card-title>Ссылка</v-card-title>
                <v-card-text>
            <v-text-field
                    label="URL"
                    v-model="item.urllink"
            ></v-text-field>
                </v-card-text>
                <v-card-actions>
                    <div class="flex-md-grow-1"></div>
                    <v-btn
                            color="#8a2be2"
                            text
                            @click="linkAdd = false"
                    >
                        OK
                    </v-btn>

                </v-card-actions>
            </v-card>

        </v-overlay>
        <v-menu top left>
            <template v-slot:activator="{ on }">
                <div style="bottom:12px; position: absolute; right: 12px">
                    <v-btn class="link-context-menu" @click="linkAdd = true"  icon  >
                        <v-icon>mdi-plus</v-icon>
                    </v-btn>
                    <v-btn class="link-context-menu" @click="$emit('move_block_left')"  icon  >
                        <v-icon>mdi-arrow-left</v-icon>
                    </v-btn>
                    <v-btn class="link-context-menu" @click="$emit('move_block_right')"  icon  >
                        <v-icon>mdi-arrow-right</v-icon>
                    </v-btn>
                    <v-btn class="link-context-menu" v-on="on" icon  >
                        <v-icon>mdi-dots-vertical</v-icon>
                    </v-btn>
                </div>

            </template>
            <v-list>

                <v-list-item @click="$emit('copy_block')">
                    <v-list-item-title>Копировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="editor = true">
                    <v-list-item-title>Редактировать</v-list-item-title>
                </v-list-item>
                <v-list-item @click="$emit('delete-link')">
                    <v-list-item-title>Удалить</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
        <div style="width:70px;height: 70px ">
            <image-uploader
                    v-model="item.img"
                    width="70"
                    height="70"
            ></image-uploader>
        </div>

        <div class="text-container">
            <span class="date"> <html-editor  v-model="item.title" ></html-editor> </span>
            <span class="look"><html-editor  v-model="item.text" ></html-editor>  </span>

        </div>

    </div>
</template>

<script>

    import ImageUploader from "./ImageUploader";
    import HtmlEditor from "./HtmlEditor";
    export default {
        name: "reportblock",
        components: {HtmlEditor, ImageUploader},
        props:['item'],
        data(){
            return{
                linkAdd:false,
            }
        },
        computed:{
            url(){
                if(item.urllink)
                {
                    return  item.urllink
                }
                else
                {
                    return  item.urllink=''
                }

            },
        }
    }
</script>

<style scoped>
    .reportblock{
        text-decoration: none;
        padding: 30px 30px 40px;
        display: flex;
        align-items: center;

        width: 100%;
        background-color: rgb(255, 255, 255);
        border-radius: 5px;
        box-shadow: rgba(0, 0, 0, 0.1) 0px 0px 10px 0px;
        height: 184px;
    }

    div img{
        width: 110px;
        height: auto;
    }

    div .text-container{
        display: flex;
        flex-direction: column;
        justify-content: left;
        align-items: flex-start;
        padding-left: 30px;
    }

    div .text-container .date{
        font-size: 24px;
        line-height: 1.35;
        font-family: 'PT Sans',Arial,sans-serif;
        font-weight: 600;
        color: #000;
    }

    div .text-container .look{
        color: #ff8562;
        font-size: 16px;
        font-family: 'PT Sans',Arial,sans-serif;
        line-height: 1.55;
        font-weight: 700;
        text-decoration: none;
        cursor: pointer;
        display: inline-block;
    }
</style>